import { defineMessages } from 'react-intl';

export default defineMessages({
    ok: {
        id: 'app.components.courseTopicsDetails.ok',
        defaultMessage: 'Ok'
    },
    topicLabel: {
        id: 'app.components.courseTopicsDetails.topicLabel',
        defaultMessage: 'Topics'
    },
    activitiesLabel: {
        id: 'app.components.courseTopicsDetails.activitiesLabel',
        defaultMessage: 'Activities'
    },
    areYouReadyLabel: {
        id: 'app.components.courseTopicsDetails.areYouReadyLabel',
        defaultMessage: 'Are you ready?'
    },
    testLabel: {
        id: 'app.components.courseTopicsDetails.testLabel',
        defaultMessage: 'Test'
    },
    exportLabel: {
        id: 'app.components.courseTopicsDetails.exportLabel',
        defaultMessage: 'Export'
    },
    topicFileLabel: {
        id: 'app.components.courseTopicsDetails.topicFileLabel',
        defaultMessage: 'TOPIC'
    },
    activitiesFileLabel: {
        id: 'app.components.courseTopicsDetails.activitiesFileLabel',
        defaultMessage: 'ACTIVITIES'
    },
    countryLabel: {
        id: 'app.components.courseTopicsDetails.countryLabel',
        defaultMessage: 'Country'
    },
    gradeLabel: {
        id: 'app.components.courseTopicsDetails.gradeLabel',
        defaultMessage: 'Grade'
    },
    authorLabel: {
        id: 'app.components.courseTopicsDetails.authorLabel',
        defaultMessage: 'Author'
    },
    easierActivitiesFileLabel: {
        id: 'app.components.courseTopicsDetails.easierActivitiesFileLabel',
        defaultMessage: 'SOMETHING EASIER ACTIVITIES'
    }
});



// WEBPACK FOOTER //
// ./app/components/course-topics-details/messages.js